import React from 'react';
import { Flag, Paintbrush, Ruler, Phone, Gift } from 'lucide-react';
const TRUST_ITEMS = [{
  icon: Flag,
  label: 'Handmade in the USA'
}, {
  icon: Paintbrush,
  label: 'Screws Painted to Match'
}, {
  icon: Ruler,
  label: 'Nearly Every Size'
}, {
  icon: Phone,
  label: 'Special Orders Welcome'
}, {
  icon: Gift,
  label: 'Great Gift Idea'
}];
export function TrustBar() {
  return <div className="bg-white border-b border-warmBorder" data-id="element-1384">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5" data-id="element-1385">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 md:gap-x-0 md:justify-between" data-id="element-1386">
          {TRUST_ITEMS.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} className="flex items-center gap-2.5 text-sm" data-id="element-1387">
                <div className="w-9 h-9 rounded-full bg-cream flex items-center justify-center flex-shrink-0" data-id="element-1388">
                  <Icon className="w-[18px] h-[18px] text-gold" strokeWidth={1.8} data-id="element-1389" />
                </div>
                <span className="font-semibold text-charcoal whitespace-nowrap" data-id="element-1390">
                  {item.label}
                </span>
              </div>;
        })}
        </div>
      </div>
    </div>;
}